import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "analyses-hero-search-results",
      attrs: { "data-qa": "analyses_hero_search_results" },
    },
    [
      _vm.isLoading
        ? _c(
            "div",
            { staticClass: "pa-4" },
            [
              _c(VSkeletonLoader, {
                attrs: { type: "list-item-two-line@3" },
              }),
            ],
            1
          )
        : _setup.hasResults
        ? _c(
            "div",
            { staticClass: "py-1" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "text-body-2 text-secondary--text px-4 pt-3 pb-1",
                },
                [_vm._v("\n      Категории\n    ")]
              ),
              _vm._v(" "),
              _vm._l(_vm.results, function (item, index) {
                return _c(
                  "a",
                  {
                    key: `${item.object_type}-${index}-${item.name}`,
                    staticClass:
                      "analyses-hero-search-results__item d-flex align-center gc-4 px-2 py-3 text-decoration-none",
                    attrs: {
                      href: item.page_url,
                      "data-qa": "analyses_hero_search_category_item",
                    },
                  },
                  [
                    _c("span", {
                      staticClass:
                        "ui-icon-layers ui-icon-fz-medium icon-secondary--text flex-shrink-0",
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column flex-grow-1 min-w-0" },
                      [
                        _c("div", {
                          staticClass: "text-body-1 text--text",
                          domProps: {
                            innerHTML: _vm._s(
                              _setup.highlightTitle(
                                item.name
                              ) /* eslint-disable-line vue/no-v-html */
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "text-body-2 text-secondary--text" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _setup.formatAnalysesCount(
                                    item.analyses_count
                                  )
                                ) +
                                "\n        "
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", {
                      staticClass:
                        "ui-icon-arrow-right ui-icon-fz-medium icon-secondary--text flex-shrink-0",
                    }),
                  ]
                )
              }),
            ],
            2
          )
        : _vm.showEmpty
        ? _c(
            "div",
            {
              staticClass:
                "d-flex flex-column gr-2 text-body-2 text-secondary--text pa-4",
              attrs: { "data-qa": "analyses_hero_search_empty" },
            },
            [
              _c("div", [
                _vm._v(
                  "\n      Ничего не нашли по запросу «" +
                    _vm._s(_setup.trimmedQuery) +
                    "»\n    "
                ),
              ]),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  "\n      Проверьте название или попробуйте другой запрос.\n    "
                ),
              ]),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }